import { Box, Stack, ContentBlock } from 'braid-design-system';

import { encodeSvg } from 'src/utils/helpers';

import AnnounceSvg from './Announce.svg?raw';
import ConnectingSvg from './Connecting.svg?raw';
import FixingSvg from './Fixing2.svg?raw';
import NoMatchSvg from './NoMatch.svg?raw';
import NothingSvg from './Nothing.svg?raw';

type ImageType = 'Announce' | 'Nothing' | 'Fixing' | 'Connecting' | 'NoMatch';

const ImageOptions = {
  Announce: AnnounceSvg,
  Nothing: NothingSvg,
  Fixing: FixingSvg,
  Connecting: ConnectingSvg,
  NoMatch: NoMatchSvg,
};
interface Props {
  children: React.ReactNode;
  image?: ImageType;
}

export const ErrorWrapper = ({ children, image = 'Nothing' }: Props) => (
  <ContentBlock width="small">
    <Box paddingY={['none', 'xxlarge']}>
      <Box
        background="surface"
        paddingY={['xxlarge', 'xlarge']}
        paddingX="gutter"
      >
        <Stack space={['large', 'xlarge']} align="center">
          <Box
            style={{
              width: image === 'Fixing' ? '254px' : '128px',
              height: '128px',
              background: encodeSvg(ImageOptions[image]),
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
            }}
          />
          <Box>{children}</Box>
        </Stack>
      </Box>
    </Box>
  </ContentBlock>
);
